module.exports = __webpack_public_path__ + "static/private-public-9c999ba3bf337fbb3b002e093504cda7.png";